import { Injectable } from '@angular/core';
import { HttpClientService } from '../implementacion/http-client.service';
import { environment } from 'src/environments/environment';
import { autenticar } from '../../models/SicarMap/Inicio/autenticar.model';
import { map } from 'rxjs/operators';
import { resetPassword } from '../../models/SicarMap/Inicio/resetPassword.model';
import { Usuario } from '../../models/SiicartAdm/Usuario.model';
import { HttpClient as Http, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class AuthService {
  IdUsuario: number;
  Usuario: any;
  UsuarioForgot: any;
  public Mailing = new Subject<any>();

  constructor(private http: HttpClientService, private httpd: Http) { }
  getToken(): string {
    return localStorage.getItem('token');
  }

  login(credencial: autenticar) {
    return this.http.post(`${environment.apiScar}Cuenta/Autorizacion`, credencial)
      .pipe(map(response => response));
  }
  forgotUser(credencial: resetPassword) {
    return this.http.get(`${environment.apiScar}Cuenta/ObtenerDatosUsuario?usuario=${credencial.usuario}`)
      .pipe(map((res: Usuario) => {
        if (res && res.semail !== undefined || res.semail !== null) {
          const dataMailing = {
            sendTo: res.semail,
            sendMesage: {
              nameuser: res.snombre,
              username: res.susuario,
              password: res.scontrasena,
              urlplatform: 'https://siicart.aguapuebla.mx/'
              //urlplatform: 'https://siicart.hi2o.mx/'
            },
            sendPlatform: 'SIICART'
          };
          return dataMailing;
        }
      }));
  }

  resetPasswordMailing(dataMailing: any) {
    return this.http.post(`${environment.apimailing}mail/reset/siicart`, dataMailing);
  }

  getTokenPortal() {

    let url = 'https://arcgisoucportal.aguapuebla.mx/arcgis/sharing';
    let us =  'equipoDesarrollo';
    let pss = '!$P0rt4lD3v#';
    let tokenEndpoint = "rest/generateToken";

    const formData = new FormData();
    formData.append("username", us);
    formData.append("password", pss);
    formData.append("referer", "null" !== window.origin ? window.origin : window.location.origin);
    formData.append("expiration", "1380");
    formData.append("f", "json");
    formData.append("urlAccessPortal", (url + tokenEndpoint));
    return this.httpd.post('https://arcgisoucportal.aguapuebla.mx/arcgis/sharing/rest/generateToken', formData);

  }

  RegistrarUsuario(credencial: autenticar) {
    return this.http.post(`${environment.apiScar}Cuenta/RegistrarUser`, credencial)
      .pipe(map(response => response));
  }

  getUser() {
    return this.http.get(`${environment.apiScar}Cuenta/AutorizacionGU`)
      .pipe(map(response => response));
  }

  sendEmail(toEmail: string){
    return this.http.post(`${environment.apiScar}TokenReset/request`, {email: toEmail});
  }


  validarNUsuario(usuario: string, email: string, claveUsuario: number) {
    return this.http.get(`${environment.apiScar}Cuenta/ValidarNuevoUsuario?usuario=${usuario}&email=${email}&ClaveUsuario=${claveUsuario}`)
      .pipe(map(response => response));
  }

}
